import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input, input } from '@angular/core';
import { SpinnerProperties } from '@dxc-technology/halstack-angular/lib/dxc-spinner/dxc-spinner.types';
import { ThemeModule, DxcSpinnerModule } from '@dxc-technology/halstack-angular';

@Component({
    selector: 'custom-spinner',
    templateUrl: './custom-spinner.component.html',
    styleUrls: ['./custom-spinner.component.scss'],
    imports: [ThemeModule, DxcSpinnerModule]
})
export class CustomSpinnerComponent {
  /**
   * The value of the progress indicator. If it's received the
   * component is determinate, otherwise is indeterminate.
   */
  readonly value = input<number>(undefined);
  /**
   * Text to be placed inside the spinner.
   */
  readonly label = input<string>(undefined);
  /**
   * Available modes of the spinner ('large' | 'small' | 'overlay').
   */
  readonly mode = input<SpinnerProperties['mode']>('large');
  /**
   * Size of the margin to be applied to the component ('xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge').
   * You can pass an object with 'top', 'bottom', 'left' and 'right' properties in order to specify different margin sizes.
   */
  readonly margin = input<SpinnerProperties['margin']>(undefined);
  /**
   * If true, the value is displayed inside the spinner..
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get showValue(): boolean {
    return this._showValue;
  }
  set showValue(value: boolean) {
    this._showValue = coerceBooleanProperty(value);
  }
  private _showValue = false;
}
